import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  card: {
    display: 'flex',
    margin: '16px',
    width: '900px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    flexDirection: 'column',
    [theme.breakpoints.down('500')]: {
      width: '100%',
      margin: 0,
      borderRadius: 0,
    },
  },

  title: {
    padding: '0 16px'
  },

  cont: {
    padding: '16px',
    height: 500,
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'scroll',
    [theme.breakpoints.down('932')]: {
      '&': {
        height: 'calc(100vh - 224px)',
      },

    },
    [theme.breakpoints.down('500')]: {
      height: 'inherit',
      overflow: 'unset',
      maxHeight: 'none',
    },
  },

  skelets: {
    paddingTop: '16px',
    '& > *': {
      marginBottom: '16px',
      borderRadius: '5px'
    }
  },

  tabs: {
    textAlign: 'center',
    backgroundColor: theme.palette.primary.main,
    height: 48,
    flex: 'none',
    borderRadius: 10,
    display: 'flex',
    position: 'relative',
    boxShadow: 'rgb(0 0 0 / 4%) 0px 10px 10px',
    marginBottom: '16px',

    '& button': {
      all: 'unset',
      position: 'relative',
      width: '100%',
      cursor: 'pointer',
      fontWeight: '500',
      color: 'rgba(255,255,255,.8)',

      '&.active': {
        color: 'white',

      }
    },
  },
  tab_indicator: {
    position: 'absolute',
    bottom: '0',
    left: '0',
    width: '50%',
    height: 4,
    transition: 'opacity .3s',
    display: 'flex',
    justifyContent: 'center',
    transition: 'all .3s ease-in-out',

    '&:before': {
      content: '""',
      backgroundColor: 'white',
      width: '70%',
      borderRadius: '5px 5px 0 0',
    }
  },



}))